import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {UntypedFormControl} from "@angular/forms";
import {IGenericKeyValue} from "../../../storage/interfaces/generic.interface";
import {GenericKeyValueFormGroup} from "../../../storage/models/generic-key-value-form-group";

@Component({
    selector: 'app-arkema-input-with-unit',
    templateUrl: './arkema-input-with-unit.component.html',
    styleUrls: ['./arkema-input-with-unit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ArkemaInputWithUnitComponent implements OnInit {

  @Input() controlFC: UntypedFormControl;
  @Input() unitControlFG: GenericKeyValueFormGroup;
  @Input() unitList: IGenericKeyValue[];
  @Input() class: string[];
  @Input() labelId: string;
  @Input() minValue: number = 0;
  @Input() maxValue: number;
  @Input() showErrors: boolean = true;
  @Input() readonly: boolean = false;
  @Input() step: number;
  @Input() hint: string = '';

  unitKeyFC = new UntypedFormControl();

  constructor() { }

  ngOnInit(): void {
    // add unitflowrate value if null with first unit list value
    if (!this.unitControlFG.keyFC.value && !!this.unitList.length) {
      this.unitControlFG.patchValue(this.unitList[0], {emitEvent: true});
    }
    this.unitKeyFC.setValue(this.unitControlFG.keyFC.value);

    this.unitKeyFC.valueChanges.subscribe((value: IGenericKeyValue) => {
      this.unitControlFG.patchValue(value, {emitEvent: true});
    });
  }

  compareByKey(o1: IGenericKeyValue, o2: string): boolean {
    return (o1 && o2 && o1['key'] === o2);
  }

}
